import * as React from 'react';
import {DefaultButton, Dropdown, PrimaryButton} from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {SpinButton, Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import NetGrossPicker from "../../Components/NetGrossPicker";

function EditProject(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState(props.edit.name || '');
    const [internalNumber, setInternalNumber] = useState('');
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [divider, setDivider] = useState(1);
    const [account, setAccount] = useState(0);
    const [whole, setWhole] = useState(1);
    const [number, setNumber] = useState('');
    const [location, setLocation] = useState('');
    const [locationNumber, setLocationNumber] = useState('');
    const [ventures, setVentures] = useState([]);
    const [venture, setVenture] = useState(null);

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            name: name,
            net_value: net,
            vat: vat,
            gross_value: gross,
            id: props.edit.id,
            account: account,
            divider: divider,
            internal_number: internalNumber,
            number: number,
            whole: whole,
            location: location,
            location_number: locationNumber,
            venture_id: venture.key
        };
        fetch(`/api/project/${props.edit.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditProject'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setName(props.edit.name || '');
        setAccount(props.edit.account || props.edit.project_account || '');
        setNet(props.edit.net_value ?? 0);
        setVat(props.edit.vat ?? 0);
        setGross(props.edit.gross_value ?? 0);
        setDivider(props.edit.divider || 1);
        setInternalNumber(props.edit.internal_number || 0);
        setNumber(props.edit.number || '');
        setLocation(props.edit.location || '');
        setLocationNumber(props.edit.location_number || '');
        setWhole(props.edit.whole || 1);
        setVenture({key: props.edit.venture_id} || 1);
        async function fetchData() {
            await fetch("/api/venture", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setVentures(data.map((item) => ({key: item.id, text: item.name}))) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [props.edit, user.token])


    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Projekt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <p>{props.edit.keystring}</p>
            <form onSubmit={_submit} id='EditProject'>
                <Dropdown
                    label="Kontrakt"
                    selectedKey={venture ? venture.key : undefined}
                    onChange={(e, item) => setVenture(item)}
                    placeholder="Wybierz z listy"
                    options={ventures}
                />
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField label='Numer Wewnętrzny' value={internalNumber} onChange={(e) => setInternalNumber(e.target.value || '')}/>
                <TextField label='Konto' value={account} onChange={(e) => setAccount(e.target.value || '')}/>
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <SpinButton
                    label={'Rozmiar Lokalu:'}
                    labelPosition={'top'}
                    min={0.0001}
                    step={0.0001}
                    max={10000000000}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={divider}
                    onChange={(e) => setDivider(e.target.value || '')}
                />
                <SpinButton
                    label={'Rozmiar Działki:'}
                    labelPosition={'top'}
                    min={0.0001}
                    step={0.0001}
                    max={10000000000}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={whole}
                    onChange={(e) => setWhole(e.target.value || '')}
                />
                <TextField label='Numer Działki' value={locationNumber} onChange={(e) => setLocationNumber(e.target.value || '')}/>
                <TextField label='Budynek' value={number} onChange={(e) => setNumber(e.target.value || '')}/>
                <TextField label='Poziom na' value={location} onChange={(e) => setLocation(e.target.value || '')}/>
            </form>
        </Panel>
    )
}

export default EditProject;